import { createSelector } from 'reselect';

import {
  activeItemSelector,
  notificationsSelector,
} from '@xingternal/platform-layout-selectors';

const secondaryItemSelector = createSelector(
  activeItemSelector,
  notificationsSelector,
  (activeItem, notifications) => ({
    activeItem,
    notifications,
  })
);

export { secondaryItemSelector };
